import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuthGlobal from "src/context/useAuthGlobal";

const withAuth = (WrappedComponent) => {
  const AuthenticatedComponent = (props) => {
    const isAuthenticated = localStorage.getItem("token");
    const router = useNavigate();
    const { userMe } = useAuthGlobal();

    useEffect(() => {
      if (isAuthenticated === null || (isAuthenticated === null && !userMe)) {
        router("/");
      }
    }, [router, userMe, isAuthenticated]);

    return (
      <React.Fragment>
        {localStorage.getItem("token") ? <WrappedComponent {...props} /> : null}
      </React.Fragment>
    );
  };

  return AuthenticatedComponent;
};

export default withAuth;
